import React, { ReactNode } from "react";
import { Button as MUIBtton } from "@mui/material";
import classNames from "classnames";

interface ButtonProps {
  children?: ReactNode;
  className?: string;
  icon?: ReactNode;
  disabled?: boolean;
  type?: "primary" | "secondary" | "text";
  appearance?: "warning" | "error" | "success" | "info" | "default";
  corners?: "default" | "rounded" | "circle";
  onClick?: () => void;
}

const Button = (props: ButtonProps) => {
  const {
    children,
    className,
    disabled,
    icon,
    type = "secondary",
    appearance,
    corners,
    onClick,
  } = props;

  const btnClassName = classNames(className, "dui-btn", {
    [`dui-btn-${type}`]: type !== undefined,
    [`dui-btn-${appearance}`]: appearance !== undefined,
    [`dui-btn-${corners}`]: corners !== undefined,
    "dui-btn-icon-only": icon !== undefined && children === undefined,
    "dui-btn-disabled": disabled,
  });

  return (
    <MUIBtton className={btnClassName} onClick={onClick} disabled={disabled}>
      <div className="dui-btn-inner">
        {icon !== undefined && <div className="dui-btn-icon">{icon}</div>}
        {children !== undefined && (
          <div className="dui-btn-text">{children}</div>
        )}
      </div>
    </MUIBtton>
  );
};

export default Button;
